import React, { Component } from 'react';
import { ProjExelLogo } from '../../../assets/images';
import './BeforeAuthHeader.scss';

export default class BeforeAuthHeader extends Component {
  render() {
    return (
      <>
        <header>
          <nav>
            <div className="row">
              <div className="col-md-12">
                <img src={ProjExelLogo} alt="ProjExel Logo" className="logo" />
              </div>
            </div>
          </nav>
        </header>
      </>
    )
  }
}